import * as types from "./type";

export const showToast = (payload) => {
  return {
    type: types.SHOW_TOAST,
    payload, // { message: string, type: "success" | "error" | "info" | "warning" }
  };
};

export const hideToast = () => {
  return {
    type: types.HIDE_TOAST,
  };
};